import Page from '../../components/Page';
import {
    Box,
    Tabs,
    Tab,
    Typography,
} from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

import { CustomerSurveyView } from './CustomerSurveyView';
import ProcessorSurveyView from './ProcessorSurveyView';
import { canAccess } from '../../permissions/canAccess';
import { AppViewIds } from '../../permissions/appViewIds';
import { isBotmarkSuperAdmin } from '../../permissions/roleUtils';
import TabPanel from '../../components/TabPanel';
import { usePermissionState } from '../../stores/permissionStore';

export function SurveyPage({ companyIdOverride, companyNameOverride, embedded = false, showReceivedOverride }){
    /// Survey Page
    const [value, setValue] = React.useState(0);
    const currentCompany = useSelector((state) => state.CompanyReducer.userCompanies[0]);
    const user = useSelector((state) => state.UserReducer.isAuthenticated);

    const companyId = companyIdOverride ?? currentCompany?.id;

    const handleTabChange = (event, newValue) => {
        setValue(newValue);
    };

    const permissionState = usePermissionState();

    const superAdminOverride = isBotmarkSuperAdmin(user);
    const showReceivedAndSent = Boolean(
        showReceivedOverride ?? (superAdminOverride || canAccess(AppViewIds.SurveysReceived, permissionState))
    );
    const showSentOnly = !showReceivedAndSent
        && (canAccess(AppViewIds.SurveysSent, permissionState) || superAdminOverride);
    const body = (
        <Box>
            {!embedded && (
                <Typography variant="h6" component="h2">
                    Surveys
                </Typography>
            )}
            {showReceivedAndSent && (
                <>
                    <Tabs value={value} onChange={handleTabChange} style={{ borderBottom: '2px solid darkGray', paddingBottom: '10px',overflowX:"scroll", scrollbarWidth:'none'}}>
                        <Tab label="Received" />
                        <Tab label="Sent" />
                    </Tabs>
                    <TabPanel unmountInactive className="companyTab" value={value} index={0} style={{}}>
                        <ProcessorSurveyView companyIdOverride={companyId} embedded />
                    </TabPanel>
                    <TabPanel unmountInactive className="companyTab" value={value} index={1} style={{}}>
                        <CustomerSurveyView companyIdOverride={companyId} companyNameOverride={companyNameOverride} embedded />
                    </TabPanel>
                </>
            )}
            {showSentOnly && (
                <>
                    <Tabs value={value} onChange={handleTabChange} style={{ borderBottom: '2px solid darkGray', paddingBottom: '10px',overflowX:"scroll", scrollbarWidth:'none'}}>
                        <Tab label="Sent" />
                    </Tabs>
                    <TabPanel unmountInactive className="companyTab" value={value} index={0} style={{}}>
                        <CustomerSurveyView companyIdOverride={companyId} companyNameOverride={companyNameOverride} embedded />
                    </TabPanel>
                </>
            )}
        </Box>
    );

    if (embedded) return body;
    return (
        <Page title="Surveys">
            {body}
        </Page>
    );
};
